<template>
    <div class="project-list row">
        <div class="project-container clear col-md-12" tabindex="0">
            <div class="ibox relative">
                <div class="ibox-heading clearfix" tabindex="0">
                    <h2>{{ `${t_title} (${ inner_projects.length })` }}</h2>
                    <div class="m-t-lg" tabindex="0">
                        <v-btn v-if="register_project_available==='1'" type="button" class="btn btn-primary button-add-license m-r-sm" @click="showAddNewProjectModal()">
                            <i class="fa-regular fa-plus fa-lg m-r-sm"></i>&nbsp;{{ t_project_from_license }}
                        </v-btn>
                        <v-btn v-if="demo_project_available==='1' && isSuperAdmin" type="button" class="btn btn-primary button-add-license m-r-sm" @click="showAddNewDemoProjectModal()">
                            <i class="fa-regular fa-plus fa-lg m-r-sm"></i>&nbsp;{{ t_new_demo_project }}
                        </v-btn>
                    </div>
                </div>
                <div class="ibox-content pt-0 mt-0" tabindex="0">
                    <div v-for="(project,key) in inner_projects"
                         :key="project.id"
                         @click="selectProject(project)"
                         :class="[{ 'inactive': project.active===0 }, 'file-box project btn']"
                         :style="{cursor: project.active===0 ? 'default' : ''}"
                         tabindex="0"
                    >
                        <div class="file no-selection" :class="{ 'project-selected': project.selected }" :style="`--outline-color: ${project.color}`" tabindex="0">
                            <div class="project-logo" tabindex="0"
                                 :style="{cursor: project.active===0 ? 'default' : '', backgroundImage: 'url(\''+logo(project)+'\')', backgroundColor: project.color}">
                            </div>
                            <i class='fa-solid fa-circle' :class="project['status-class']" tabindex="0"
                               style='position:absolute;top:6px;left:6px;filter: drop-shadow(0px 0px 2px #555);'>
                            </i>
                            <div class="file-name wrap-text project-file-name" tabindex="0">
                                <strong>{{project.name}}</strong>
                                <br>
                                <small v-if="project.validity">{{t_validity}}: {{project.validity}}</small>
                                <br>
                            </div>
                        </div>
                    </div>
                    <div v-if="inner_projects.length === 0">
                        <h4>{{ t_no_projects }}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                t_title: Lang.langChoice("Project|Projects", 2),
                t_validity: Lang.langGet("Project valid until"),
                t_edit: Lang.langGet("Edit"),
                t_no_projects: Lang.langGet("No active project available."),
                t_project_from_license: Lang.langGet("Create or connect project"),
                t_new_demo_project: Lang.langGet("Create demo project"),
                inner_projects: [],
            }
        },
        props: [
            'logo_folder',
            'projects',
            'back_url',
            'register_project_available',
            'demo_project_available',
            'sso_add_project'
        ],
        methods: {
            showAddNewProjectModal: function () {
                EaseEventBus.fire('modifyMode', {'mode': 'add-new-or-connect-project', 'ssoOverride': this.sso_add_project});
                EaseEventBus.fire('showModal', 'edit-license');
            },
            showAddNewDemoProjectModal: function () {
                EaseEventBus.fire('createDemo', this.sso_add_project);
            },
            logo: function (project) {
                if(project.thumbnail_url !== null) {
                    return this.logo_folder + project.thumbnail_url;
                } else {
                    return "/img/logo-easescreen-white.png"
                }
            },
            selectProject : function(project) {
                if(project.active === 1) {
                    axios.post('project-selection', {
                        projectID: project.id
                    }).then(() => {
                        window.location = this.back_url;
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            window.location = '/login';
                        }
                    });
                }
            },
        },
        computed: {
            isSuperAdmin() {
                return Laravel.isUserSuperAdmin;
            }
        },
        mounted() {
            this.inner_projects = JSON.parse(this.projects);

            const selectedProjectIndex = this.inner_projects.findIndex(project => project.id == Laravel.activeProject)
            if(selectedProjectIndex >= 0) {
                this.inner_projects[selectedProjectIndex]['selected'] = true
            }
        }
    }
</script>

<style scoped>
    .project-selected {
        --outline-color: var(--color-primary, #003371);
        outline: 4px solid var(--outline-color);
        outline-offset: -4px;
    }
</style>
